<script>
	export default {
		props: {
			isdisabled: {
				type: Boolean,
				required: false,
				default: false
			},
			val: {
				type: null, // any
				required: true
			},
			changeCallback: {
				type: Function,
				required: false,
				default: () => {}
			},
			closed: {
				type: null,
				default: 0
			}
		},
		data() {
			return {
				choices: [
					{ value: 100, text: 'Correct' },
					{ value: 75, text: '.75' },
					{ value: 50, text: '.50' },
					{ value: 25, text: '.25' },
					{ value: 0, text: 'Incorrect' }
				]
			};
		},
		methods: {
			clickChoice(newVal) {
				const updatedVal = newVal === this.val ? null : newVal;

				this.$emit('update:val', updatedVal);
				this.changeCallback(updatedVal);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';

	.question-score-chooser {
		.assignment-unsubmitted {
			font-style: oblique;
		}

		.button.-grading {
			margin-right: 0.4em;
			margin-bottom: 0.4em;
			@media only screen and (max-width: 450px) {
				display: block;
				text-align: center;
			}
		}

		&.-narrow {
			margin-top: 0.6em;
			display: block;
		}
		&.-wide {
			display: none;
		}
		@media only screen and (min-width: $bp-width-med) {
			white-space: nowrap;
		}
		@media only screen and (min-width: $bp-width-lg) {
			&.-narrow {
				display: none;
			}
			&.-wide {
				display: block;
				float: right;
			}
		}
	}
</style>
<template>
	<span class="question-score-chooser">
		<span
			v-if="isdisabled && !closed"
			class="assignment-unsubmitted">
			Unsubmitted
		</span>
		<span
			v-if="isdisabled && closed"
			class="assignment-unsubmitted">
			Incorrect
		</span>
		<span v-if="!isdisabled">
			<template v-for="c in choices">
				<button
					:class="['button', '-grading', '-small', { [`-grade-${c.value}`]: c.value === val }]"
					:data-grade="c.value"
					@click="clickChoice(c.value)">
					{{ c.text }}
				</button>
			</template>
		</span>
	</span>
</template>
